module.exports = __webpack_public_path__ + "img/send-offer-mobile-en.93f2b07e.jpg";